import styled from 'styled-components';

import { Box } from '../../common/ui/Box';

export const StatisticsCenteredFrame = styled(Box)`
    display: flex;
    justify-content: center;
    margin-top: 124px;
`;
